<template>
  <ErrorBoundary>
    <div
      v-if="addOns && addOns?.length > 0"
      class="event-date-picker__input mt-2"
    >
      <label class="text-sm">{{ $t('product.addOn.addOnLabel') }}</label>
      <Select
        v-model="selectedAddOn"
        :options="addOns"
        :transformer-fn="
          (option: EventAddOn, idx: number) => ({
            id: option.id,
            value: option,
            label: getAddOnLabel(option),
          })
        "
        class="!rounded-lg"
        size="small"
        :data-test-id="`event-buy-box--add-on-select`"
        :placeholder="$t('product.addOn.addOnPlaceholder')"
        :enable-deselect-option="true"
      />
    </div>
  </ErrorBoundary>
</template>

<script lang="ts" setup>
import type { EventAddOn, EventDescription } from '~/composables/types/event'
import { formatMoney } from '~/utils/currencyHelpers'
const eventData = inject('eventData') as EventDescription

const { locale, t } = useI18n()

const eventId = computed(() => eventGetters.getId(eventData))
const { data: addOnsResponse } = await useKftApiFetch(
  `v1/store/events/${eventId.value}/add-ons?include=media`
)
const addOns = computed(() => addOnsResponse.value?.data)
const selectedAddOn = defineModel<EventAddOn>({
  default: undefined,
})

const getAddOnLabel = (addOn: EventAddOn) => {
  const price = getAddOnPrice(addOn)

  const priceSuiffix =
    getEventAddOnPriceType(addOn) === 'PER_SESSION'
      ? t('product.ticketCardsSection.perGroup')
      : t('product.ticketCardsSection.perPerson')
  return price ? `${addOn?.name} : ${price} ${priceSuiffix}` : addOn?.name
}

const getAddOnPrice = (addOn: EventAddOn) => {
  if (!addOn?.unit_price?.amount) {
    return ''
  }

  const amount =
    typeof addOn?.unit_price?.amount === 'number'
      ? addOn?.unit_price?.amount / 100
      : parseInt(addOn?.unit_price?.amount, 10) / 100

  return formatMoney(amount, locale.value, 'EUR', 2)
}
</script>
